import Config from '../definitions/Config';
import fetchJSON from './fetchJSON';


const API_ENDPOINT_RH = `${Config.PROFILE_BFF_URL}/get-logins`;

/**
 *
 * @returns {Promise<*>}
 */
async function fetchActiveLogins() {
    const jsonResponse = await fetchJSON({
        url: API_ENDPOINT_RH, 
        options: { credentials: 'include' },
    }, 'fetchActiveLogins');

    const { hasRatehubLogin } = jsonResponse.data;

    return { hasRatehubLogin };
}


export {
    fetchActiveLogins,
    API_ENDPOINT_RH,
};
